/**
 * Loest einen vom Backend gespeicherten Bild-Pfad zur Anzeige-URL auf.
 *
 * Bild-Pfade aus der Datenbank (z.B. `/api/blog/image/...`, `/media/...`)
 * sind bewusst RELATIV gespeichert, damit sie portabel sind — dieselbe DB
 * funktioniert unveraendert in jeder Umgebung (lokal, Preview, Hetzner-Test,
 * spaeter Produktion). Absolute URLs duerfen NIE in die DB geschrieben
 * werden (sonst haengt z.B. "localhost:8010" fest drin und ist auf jeder
 * anderen Maschine bedeutungslos) — die Aufloesung zur aktuellen
 * Backend-Adresse passiert immer erst hier, beim Rendern.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const resolveImageUrl = (src) => {
  if (!src) return src;
  if (src.startsWith('http') || src.startsWith('data:')) return src;
  return `${API_URL}${src}`;
};

export default resolveImageUrl;
